import { ModelValidator } from './model-validator';

export abstract class PaymentMethod extends ModelValidator {
    abstract getExpiryDateOneWord(): string;
}
